import React from 'react';
import $ from 'jquery';
import VolumeService from '../../services/volume.service';
import ReactToolTip from 'react-tooltip';
import { isPositiveNonZero } from '../../utility/utility';
import { AuditLog } from '../../services/auditlog.service';
import { getMessage } from '../../constants/messagesMapper';
import { FlavorService } from './../../services/flavor.service';
export default class VolumeBackup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            backupList: [],
            selectedBackup: {},
            errorMessg: '',
            backupName: '',
            volumeName: '',
            size: '10',
            columnType: 'date',
            nameToggle: false,
            regionToggle: false,
            dateToggle: true,
            sizeToggle: false,
            isNewVolumeRestore: true,
            regionVolumeList: [],
            indexCount: 0,
            count: 50,
            backupPaged: [],
            discId: "",
            discCode: "",
            discPerce: "",
            discVal: "",
            volPrice: 0.1,
        };
    }

    componentDidMount() {
        this.setBackupList(true);
        this.setDiscount();
    }
    setDiscount() {
        FlavorService.getDiscounts().then(resp => {
            if(Array.isArray(resp)) {

                for(let i = 0; i < resp.length; i++) {
                    if(resp[i].code_type == "cloud") {
                        let ob = resp[i];
                        this.setState({ discId: ob.id, discCode: ob.code, discPerce: ob.discount, discVal: 100 / ob.discount });
                    }

                }

            }
        });
    }

    getRegionUrl(region) {
        return this.props.regionList.find(item => item.region === region).url;
    }

    onRowMenuClick = (event, backup) => {
        this.setState({ selectedBackup: backup });
        $(event.currentTarget).closest('.tr').find('.dropdown_component ').toggleClass('active');
        // $(".volumes_row_options").css({ "z-index": 9999});
    };

    setBackupList(isInitial) {
        VolumeService.getBackupList().then(resp => {
            if(resp && resp.length >= 0) {
                let backupList = this.getSortableData(this.state.columnType, resp);
                let backupPaged = backupList;
                if(backupPaged && backupPaged.length > this.state.count) backupPaged = resp.slice(0, this.state.count);
                this.setState({ backupList: backupList, backupPaged: backupPaged }, () => this.activateActionMenu());
                sessionStorage.backupList = JSON.stringify(resp);
                sessionStorage.backupsLength = resp.length;
                if(isInitial) {
                    let creatList = resp.filter(item => item.status === 'creating');
                    this.invokeSeperatePolling(creatList);
                }
            }
        });
    }

    invokeSeperatePolling(creatList) {
        let geturl = window.location.href;
        if(geturl.indexOf("volumes") === -1) {
            return;
        }
        if(creatList !== undefined && creatList.length > 0) {
            creatList.forEach(elem => {
                this.setVolumeStatus(elem.id, elem.region);
            });
        }
    }

    setVolumeStatus(backupId, region) {
        VolumeService.getBackupById(backupId, region).then(resp => {
            if(resp !== null && resp !== undefined && resp.backup && resp.backup.status) {
                let backupElem = resp.backup;
                if(backupElem.status !== 'creating') {
                    let backupList = this.state.backupList;
                    let index = backupList.findIndex(item => item.id === backupId);
                    let elem = backupList[index];
                    elem.status = backupElem.status;
                    backupList[index] = elem;
                    this.setState({ backupList: backupList });
                    return;
                } else if(backupElem.status === 'creating') {
                    let time = backupElem.size > 5 ? backupElem.size * 2000 : 10000;
                    sessionStorage.itemInterval = setTimeout(() => this.setVolumeStatus(backupId, region), time);
                }
            }
        });
    }

    componentWillUnmount() {
        //clearTimeout(sessionStorage.itemInterval)
    }

    activateActionMenu() {
        var documentwindowHeight = $(document).height();
        $('.dashboard_module .table_data .tr .row_menu_icon, .tabular_data_wrap li .menu_icon').click(function () {

            $('.tabular_data_wrap .table_data .tr').removeClass('row_selected');
            $(this).closest('.tr').addClass('row_selected');
            //$(this).closest('.dashboard_module .tr').find('.dropdown_component').toggleClass('row_selected');
            $(this).find('.dropdown_component').css({ top: '30px' });
            let fmi = 'dropdown_component';
            var offset = $(this).offset();
            var x = (offset.left);
            var y = (offset.top);
            var windowHeight = $(window).height();
            var menuHeight = $(this).find('.' + fmi).height();
            var totalHeight = menuHeight + y;
            // alert("totHeight:" + totalHeight);
            // alert("docwindowHeight:" + documentwindowHeight);
            if((windowHeight <= 800) && (menuHeight <= 200)) {
                totalHeight = totalHeight + 50;
            }
            if(documentwindowHeight < totalHeight) {
                $('.' + fmi).css({ top: -Math.abs(menuHeight + 10) });
                $('.arrow_pointer').addClass('bottom_arrow');

                if(windowHeight < 800) {
                    //alert('test 1' + windowHeight)
                    totalHeight = totalHeight - windowHeight;
                    totalHeight = totalHeight - $(this).find('.dropdown_component').innerHeight();
                    totalHeight = totalHeight + 50;
                    //alert('1 condition'+totalHeight);
                    window.scrollTo({ top: totalHeight, behavior: 'smooth', });
                    $(this).find('.dropdown_component').css({ zIndex: '999' });
                }
            }
            else if(documentwindowHeight > totalHeight) { //alert('test 2')
                totalHeight = totalHeight - windowHeight;
                totalHeight = totalHeight + 50;
                $('.arrow_pointer').removeClass('bottom_arrow');

                window.scrollTo({ top: totalHeight, behavior: 'smooth', });
            }

        });
    }

    deleteBackup() {
        this.props.bgShadowHandler(true);
        this.deleteBckupClose();
        let selectedBackup = this.state.selectedBackup;
        VolumeService.deleteBackupById(selectedBackup.id, selectedBackup.region).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp === null) {
                let backups = this.state.backupList;
                let filtBackups = backups.filter(item => item.id !== selectedBackup.id);
                let backupPaged = filtBackups;
                sessionStorage.backupList = JSON.stringify(filtBackups);
                if(backupPaged && backupPaged.length > 0) backupPaged = backupPaged.slice(0, this.state.count);
                this.setState({ backupList: filtBackups, indexCount: 0, backupPaged: backupPaged });
                sessionStorage.backupsLength = filtBackups.length;
                this.props.msgHandler('Successfully deleted the backup ' + selectedBackup.name, '');
                const backupBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Backup " + selectedBackup.name + " has been deleted",
                    "operation": "Volume backup deletion",
                    "region": selectedBackup.region
                };
                AuditLog.storeAuditLogs(backupBody, "instance").then((resp) => {
                    if(resp === false);
                });
                return;
            }
            this.props.msgHandler('Failed to delete, try again', 'error');
        });
    }

    formHandler = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        if(name === 'size' && val !== '' && !isPositiveNonZero(val)) {
            return;
        }
        this.setState({ [name]: val, errorMessg: '', volErrorMessg: '' });
    };

    editBackup() {
        if(this.state.backupName === undefined || this.state.backupName.trim() === '') {
            this.setState({ errorMessg: 'Name should not be blank' });
            return;
        }
        if(this.state.backupName.trim() === this.state.selectedBackup.name) {
            this.setState({ errorMessg: 'Enter a new name for backup' });
            return;
        }
        // else if(this.isSnapshotExist(this.state.backupName,this.state.selectedBackup.region)) {
        //     this.setState({ errorMessg: 'Snapshot name should not be duplicate' });
        //     return;
        // }
        this.props.bgShadowHandler(true);
        this.deleteBckupClose();
        let selectedBackup = this.state.selectedBackup;
        let requestBody = {
            "backup": {
                "name": this.state.backupName.trim()
            }
        };
        VolumeService.updateBackupById(selectedBackup.id, requestBody, selectedBackup.region).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp && resp.backup) {
                const backupBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Volume backup name " + this.state.selectedBackup.name + " has been updated to " + this.state.backupName.trim(),
                    "operation": "Volume backup name edit",
                    "region": selectedBackup.region
                };
                AuditLog.storeAuditLogs(backupBody, "instance").then((resp) => {
                    if(resp === false);
                });
                let backup = resp.backup;
                let backupList = this.state.backupList;
                let index = backupList.findIndex(item => item.id === backup.id);
                backup.region = selectedBackup.region;
                backupList[index].name = backup.name;
                sessionStorage.backupList = JSON.stringify(backupList);

                this.props.msgHandler('Successfully edited the backup', '');
                this.setState({ selectedBackup: backupList[index], backupList: backupList, messgType: '' });
                this.editClose();

                return;
            }
            this.props.msgHandler('Failed to edit, try again', 'error');
        });
    }

    isNameExist = (name, regionName) => {
        let ob = this.props.volumeList.find(item => item.region === regionName && item.name === name.trim());
        if(ob !== undefined) {
            return true;
        }
        return false;
    };

    isSnapshotExist = (name, regionName) => {
        let ob = this.state.backupList.find(item => item.region === regionName && item.name === name.trim());
        if(ob !== undefined) {
            return true;
        }
        return false;
    };

    restoreBackup() {
        if(this.state.isNewVolumeRestore) {
            if(this.state.volumeName === undefined || this.state.volumeName.trim() === '') {
                document.getElementById('volName1').focus();
                this.setState({ errorMessg: 'Name is mandatory' });
                return;
            }
        } else {
            if(this.state.selectedVolume === undefined || this.state.selectedVolume === '') {
                if(this.state.regionVolumeList.length === 0) {
                    this.setState({ volErrorMessg: 'No Volume is available' });
                } else {
                    this.setState({ volErrorMessg: 'Select the volume' });
                }
                return;
            }
        }
        this.props.bgShadowHandler(true);
        this.setState({ errorMessg: '' });
        let selectedBackup = this.state.selectedBackup;
        let restoredVolumeName = '';

        let requestBody = {};
        if(this.state.isNewVolumeRestore) {
            requestBody = {
                restore: {
                    "name": this.state.volumeName
                }
            };
            restoredVolumeName = this.state.volumeName;
        } else {
            requestBody = {
                "restore": {
                    "volume_id": this.state.selectedVolume
                }
            };
            let ob = this.state.regionVolumeList.find(item => item.id === this.state.selectedVolume);
            if(restoredVolumeName !== undefined) {
                restoredVolumeName = ob.name;
            }
        }
        VolumeService.restoreBackupById(selectedBackup.id, requestBody, selectedBackup.region, this.state.isYearly).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp && resp.restore) {
                const backupBody = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Volume backup " + this.state.selectedBackup.name + " has been restored to " + restoredVolumeName,
                    "operation": "Volume backup restore",
                    "region": selectedBackup.region
                };
                AuditLog.storeAuditLogs(backupBody, "instance").then((resp) => {
                    if(resp === false);
                });
                this.props.refreshVolList();
                this.props.msgHandler('Successfully restored the backup ' + this.state.selectedBackup.name + ' to the volume ' + restoredVolumeName, 'success');
                this.setState({ volumeName: '' });
                this.volumeClose();
                return;
            }
            if(resp && typeof resp === 'string') {
                this.props.msgHandler(resp, 'error');
                return;
            }
            if(resp && resp.badRequest && resp.badRequest.message) {
                this.props.msgHandler(getMessage(resp.badRequest.message), 'error');
                return;
            }
            this.props.msgHandler("Couldn't restore backup " + this.state.selectedBackup.name + " to the volume " + restoredVolumeName, 'error');
        });

    }

    deleteClick = () => {
        $('#snapDel').addClass('active');
    };
    deleteBckupClose = () => {
        $('#snapDel').removeClass('active');
    };
    addVolClick = () => {
        let volumeList = this.props.volumeList;
        let selectedBackup = this.state.selectedBackup;
        let regionVolumes = volumeList.filter(item => item.region === selectedBackup.region && item.size >= selectedBackup.size && item.attachments.length === 0);
        this.setState({
            errorMessg: '',
            regionVolumeList: regionVolumes,
            volErrorMessg: '',
            volumeName: '',
            isNewVolumeRestore: true,
            selectedVolume: '',
            sizeOfBackup: selectedBackup.size,
            isYearly: this.state.selectedBackup.size >= 10 ? true : false
        });
        $('#backupVol').addClass('active');

        setTimeout(() => {
            document.getElementById('volName1').focus();
        }, 400);
    };

    volumeClose = () => {
        $('#backupVol').removeClass('active');
    };
    editBackupClick = () => {
        this.setState({ errorMessg: '', backupName: this.state.selectedBackup.name });
        $('#editBackup').addClass('active');
        setTimeout(() => {
            document.getElementById('backupname').focus();
        }, 400);
    };
    editClose = () => {
        $('#editBackup').removeClass('active');
    };

    headerSortClick = (event) => {
        $('.volMainBackup_table .sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    setSortable = (type) => {
        if(type === "name") {
            this.setState({ nameToggle: !this.state.nameToggle }, () => this.setBackups(type));
        } else if(type === "region") {
            this.setState({ regionToggle: !this.state.regionToggle }, () => this.setBackups(type));
        } else if(type === "date") {
            this.setState({ dateToggle: !this.state.dateToggle }, () => this.setBackups(type));
        } else if(type === "size") {
            this.setState({ sizeToggle: !this.state.sizeToggle }, () => this.setBackups(type));
        }
    };

    setBackups(type) {
        let backupList = this.getSortableData(type, this.state.backupList);
        let backupPaged = backupList;
        if(backupList.length > this.state.count) backupPaged = backupPaged.slice(0, this.state.count);
        this.setState({ backupList: backupList, backupPaged: backupPaged, indexCount: 0 });
    }

    getSortableData = (type, items) => {
        if(items && items.length === 0) {
            return items;
        }
        this.setState({ columnType: type });
        if(type === "name") {
            if(this.state.nameToggle) {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                    return 0;
                });
            }
            return items;
        }
        else if(type === "region") {
            if(this.state.regionToggle) {
                items.sort(function (a, b) {
                    if(a.region < b.region) { return -1; }
                    if(a.region > b.region) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.region < b.region) { return 1; }
                    if(a.region > b.region) { return -1; }
                    return 0;
                });
            }
            return items;
        }
        else if(type === "date") {
            if(this.state.dateToggle) {
                items.sort(function (a, b) {
                    return new Date(b.created_at) - new Date(a.created_at);
                });
            }
            else {
                items.sort(function (a, b) {
                    return new Date(a.created_at) - new Date(b.created_at);
                });
            }
            return items;
        }
        else if(type === "size") {
            if(this.state.sizeToggle) {
                items.sort(function (a, b) {
                    if(a.size < b.size) { return -1; }
                    if(a.size > b.size) { return 1; }
                    return 0;
                });
            }
            else {
                items.sort(function (a, b) {
                    if(a.size < b.size) { return 1; }
                    if(a.size > b.size) { return -1; }
                    return 0;
                });
            }
            return items;
        }
        return items;
    };

    restoreClick = (event, type) => {
        if(type === 'new') {
            this.setState({ isNewVolumeRestore: true, isYearly: true, selectedVolume: '', volErrorMessg: "", errorMessg: "" }, () => document.getElementById('volName1').focus());
        } else {
            this.setState({ isNewVolumeRestore: false, volumeName: '' });
        }
    };

    onBackupKeyDown = (e, type) => {
        if(e.keyCode === 13) {
            if(type === 'restoreBackup') {
                this.restoreBackup();
            }
            if(type === 'edit') {
                this.editBackup();
            }
        }
    };

    handleNextClick = (event) => {
        let backupList = this.state.backupList;
        let indexCount = this.state.indexCount + this.state.count;
        let endCount = indexCount + this.state.count;
        if(endCount > backupList.length) endCount = backupList.length;
        this.setState({
            indexCount: indexCount,
            backupPaged: backupList.slice(indexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousClick = (event) => {
        let backupList = this.state.backupList;
        let indexCount = this.state.indexCount - this.state.count;
        this.setState({
            indexCount: this.state.indexCount - this.state.count,
            backupPaged: backupList.slice(indexCount, this.state.indexCount)
        });
        event.preventDefault();
    };

    render() {
        return (
            <div className="tabular_data_wrap volMainBackup_table" style={ { display: this.props.isTabActive ? 'none' : 'block' } }>
                <div className="table_header">
                    <ul>
                        <li className="th">
                            <div className="col col1">
                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("name"); } }>Name<span className="sort_icon"></span></div>
                            </div>
                            <div className="col col2">
                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("size"); } }>Size<span className="sort_icon"></span></div>
                            </div>
                            <div className="col col3">
                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("region"); } }>Region<span className="sort_icon"></span></div>
                            </div>
                            <div className="col col4">
                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("date"); } }>Created On<span className="sort_icon active"></span></div>
                            </div>
                            <div className="col col5">Actions</div>
                        </li>
                    </ul>
                </div>
                <div className="table_data">
                    <ul> { this.state.backupPaged.length === 0 ? <li className="table_data_empty" ><div className="outer_empty_wrap fullPageEmpty">
                        <div className="inner_empty_wrap">
                            <div className="svg_wrap empty_icon backup_empty"></div>
                            <p className="empty_head">Backup</p>
                            <p className="empty_title">Enable backup from the Volumes tab to maintain a copy for recovery in case of data loss.</p>
                        </div>
                    </div></li> : this.state.backupPaged.map((backup, i) =>
                        <li className={ backup.status + " tr" } key={ i } >
                            <div className="col col1">
                                <div className="name_icon"><span className="svg_wrap"><svg x="0px" y="0px" width="30px" height="24.3px" viewBox="0 0 30 24.3" enableBackground="new 0 0 30 24.3" xmlSpace="preserve">
                                    <path fillRule="evenodd" clipRule="evenodd" fill="#59A7DA" d="M29,12.7v8c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2v-8  c0-0.2,0-0.8,0-1.4c0-0.1,0-0.6,0.2-1L4,3.7c0.7-1.3,1.4-1.9,3-2h16c1.7-0.1,2,0.6,2.9,1.9l2.9,6.8C29.1,10.9,29,12.7,29,12.7z   M3,19.7c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-6c0-0.6-0.4-1-1-1H4c-0.6,0-1,0.4-1,1V19.7z M26,9.7l-2-5c-0.2-0.5-0.4-1-1-1H7  c-0.6,0-0.8,0.5-1,1l-2,5c-0.2,0.3-0.3,0.9,0,1h22C26.4,10.7,26.2,10,26,9.7z M6,15.7h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H6  c-0.6,0-1-0.4-1-1S5.4,15.7,6,15.7z M24,15.7c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S23.4,15.7,24,15.7z"></path>
                                </svg></span></div><span className="backupName">{ backup.name }</span></div>
                            <div className="col col2"><span>{ backup.size } GB</span></div>
                            <div className="col col3"><span>{ backup.fullRegion }</span></div>
                            <div className="col col4"><span>{ formatDate(new Date(backup.created_at)) }</span></div>
                            <div className="col col5" ><span className="menu_icon" onClick={ (e) => this.onRowMenuClick(e, backup) }><span className="svg_wrap"><svg className="horizMenuIcon" data-tip data-for="actions" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                            </svg><ReactToolTip id="actions" place="top" effect="solid">Actions</ReactToolTip></span>
                                <ul className="dropdown_component volumes_row_options"  >
                                    <span className="arrow_pointer"></span>
                                    <li className="createVol" style={ { display: backup.status === 'error' ? 'none' : '' } } onClick={ () => this.addVolClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                        <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M448.8,287.9H288.5v160.3c0,17.7-14.4,32.1-32.1,32.1l0,0  c-17.7,0-32.1-14.4-32.1-32.1V287.9H64.1c-17.7,0-32.1-14.4-32.1-32.1s14.4-32.1,32.1-32.1h160.3V63.5c0-17.7,14.4-32.1,32.1-32.1  l0,0c17.7,0,32.1,14.4,32.1,32.1v160.3h160.3c17.7,0,32.1,14.4,32.1,32.1S466.5,287.9,448.8,287.9z"></path>
                                    </svg></span></span>Restore</li>
                                    <li className="editSnapshot" style={ { display: backup.status === 'error' ? 'none' : 'block' } } onClick={ () => this.editBackupClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve">
                                        <path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path>
                                    </svg></span></span>Edit</li>
                                    <li className="delete" onClick={ () => this.deleteClick() }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                        <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                    </svg></span></span>Delete</li>
                                </ul>
                            </span>
                            </div>
                            <div className="boot_container" style={ { display: backup.status === 'creating' ? '' : 'none' } }>
                                <div className="boot_wrapper">
                                    <div className="progress_wrap">
                                        <div className="title_head">
                                            <span className="head_title">Volume backup creation is in progress</span><span className="percent_num"></span>
                                        </div>
                                        <div className="progress_bar">
                                            <span className="percent_progress" style={ { width: '100%' } }></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    ) }
                    </ul>
                </div>
                <div className="pagination_inner__box remove-bg" style={ { display: this.state.backupList.length > this.state.count ? '' : 'none' } }>
                    <div className="Page_navigation">
                        <ul className="pagination_ul">
                            <li className={ this.state.indexCount === 0 ? "page-item disabled" : "page-item" }>
                                <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page1" onClick={ (event) => { this.handlePreviousClick(event); } }>
                                    <ReactToolTip id="prev-page1" place="top" effect="solid">Previous</ReactToolTip>
                                    <span aria-hidden="true">«</span>
                                    <span className="sr-only">Previous</span>
                                </a>
                            </li>
                            <li className="page-item">
                                <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                    { this.state.indexCount + 1 } - { (this.state.indexCount + this.state.count) > this.state.backupList.length ? this.state.backupList.length : (this.state.indexCount + this.state.count) }
                                </a>
                            </li>
                            <li className={ this.state.indexCount + this.state.count > this.state.backupList.length - 1 ? "page-item disabled" : "page-item" }>
                                <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page1" onClick={ (event) => { this.handleNextClick(event); } }>
                                    <ReactToolTip id="next-page1" place="top" effect="solid">Next</ReactToolTip>
                                    <span aria-hidden="true">»</span>
                                    <span className="sr-only">Next</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="main_slider editSnapshot_slider" id="editBackup">
                    <div className="slider_bg_shadow"></div>
                    <div className="slider_wrapper">
                        <div className="main_slider_container">
                            <div className="close_icon" onClick={ () => this.editClose() }></div>
                            <div className="createVol_slide_wrap">
                                <div className="head_block">
                                    <h2><span className="icon_img"> <span className="svg_wrap"><svg x="0px" y="0px" width="30px" height="24.3px" viewBox="0 0 30 24.3" enableBackground="new 0 0 30 24.3" xmlSpace="preserve">
                                        <path fillRule="evenodd" clipRule="evenodd" fill="#59A7DA" d="M29,12.7v8c0,1.1-0.9,2-2,2H3c-1.1,0-2-0.9-2-2v-8  c0-0.2,0-0.8,0-1.4c0-0.1,0-0.6,0.2-1L4,3.7c0.7-1.3,1.4-1.9,3-2h16c1.7-0.1,2,0.6,2.9,1.9l2.9,6.8C29.1,10.9,29,12.7,29,12.7z   M3,19.7c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-6c0-0.6-0.4-1-1-1H4c-0.6,0-1,0.4-1,1V19.7z M26,9.7l-2-5c-0.2-0.5-0.4-1-1-1H7  c-0.6,0-0.8,0.5-1,1l-2,5c-0.2,0.3-0.3,0.9,0,1h22C26.4,10.7,26.2,10,26,9.7z M6,15.7h12c0.6,0,1,0.4,1,1s-0.4,1-1,1H6  c-0.6,0-1-0.4-1-1S5.4,15.7,6,15.7z M24,15.7c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S23.4,15.7,24,15.7z"></path>
                                    </svg></span> </span>Edit { this.state.selectedBackup.name } </h2>
                                </div>
                                <div className="createVol_content_wrap">
                                    {/* <p className="info_txt">Modify the backup name</p> */ }
                                    <div className="common_txtBox_row">
                                        <label>Name</label>
                                        <input id="backupname" type="text" name="backupName" value={ this.state.backupName } onChange={ this.formHandler } className="txt_box" maxLength="20" autoComplete="chrome-off" onKeyDown={ (e) => this.onBackupKeyDown(e, 'edit') } placeholder="Provide a new name" />
                                        <p className="comm_error_msg"> { this.state.errorMessg } </p>
                                    </div>
                                    {/* <div className="common_txtBox_row">
                <label>Regions</label>
                <input type="text" name="" value="" className="txt_box" placeholder="New York" disabled="">
              </div> */}
                                    <div className="cta_wrap">
                                        <input type="button" name="" value="Save Changes" onClick={ () => this.editBackup() } className="common_cta_btn blue" />
                                        <input type="button" name="" value="Cancel" onClick={ () => this.editClose() } className="common_cta_btn transparentGrey" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main_popup delete_volume_popup" id="snapDel">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span onClick={ () => this.deleteBckupClose() } className="close_icon" data-toggle="tooltip" title="" data-original-title="Close"></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Delete</div>
                                </div>
                                <div className="popup_body">
                                    <p className="imp_warn_note"><strong>Warning:</strong> This will permanently delete the backup from your account. On removing the backup, all the data stored in it will be deleted. This operation is irreversible.</p>
                                    <p>Are you sure you want to delete the backup <b>{ this.state.selectedBackup.name }</b> ?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <div className="btn btn_confirm" onClick={ () => this.deleteBackup() }>Delete</div>
                                        <div className="btn btn_cancel" onClick={ () => this.deleteBckupClose() }>Cancel</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main_slider RestoreBckVol_slider" id="backupVol">
                    <div className="slider_bg_shadow"></div>
                    <div className="slider_wrapper">
                        <div className="main_slider_container">
                            <div className="close_icon" onClick={ () => this.volumeClose() }></div>
                            <div className="createVol_slide_wrap restoreSlider">
                                <div className="head_block">
                                    <h2>
                                        <span className="svg_wrap">
                                            <span className="svg_wrap">
                                                <svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M448.8,287.9H288.5v160.3c0,17.7-14.4,32.1-32.1,32.1l0,0  c-17.7,0-32.1-14.4-32.1-32.1V287.9H64.1c-17.7,0-32.1-14.4-32.1-32.1s14.4-32.1,32.1-32.1h160.3V63.5c0-17.7,14.4-32.1,32.1-32.1  l0,0c17.7,0,32.1,14.4,32.1,32.1v160.3h160.3c17.7,0,32.1,14.4,32.1,32.1S466.5,287.9,448.8,287.9z"></path>
                                                </svg>
                                            </span>
                                        </span>
                                        Restore { this.state.selectedBackup.name }
                                    </h2>
                                </div>
                                <div className="createVol_ctnr">
                                    <div className="radio_optionWrap">
                                        <ul>
                                            <li className="opt1">
                                                <div className="btn_wrap"><label className={ this.state.isNewVolumeRestore ? "custom_radio newVolumeOpt active" : "custom_radio newVolumeOpt" }>Restore to a new volume
                                                    <input type="radio" id="backupRadio" checked="checked" name="restoreVolOption" onChange={ (e) => this.restoreClick(e, 'new') } />
                                                    <span className="checkmark"></span> </label></div>
                                            </li>
                                            <li className="opt2">
                                                <div className="btn_wrap"><label className={ this.state.isNewVolumeRestore ? "custom_radio existVolumeOpt" : "custom_radio existVolumeOpt active" }>Restore to an existing volume
                                                    <input type="radio" checked="checked" name="restoreVolOption" onChange={ (e) => this.restoreClick(e, 'existing') } />
                                                    <span className="checkmark"></span> </label></div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="restVolcont_blk">
                                        <div className="newVolRestore" style={ { display: this.state.isNewVolumeRestore ? "block" : "none" } }>
                                            <ul className="volSliderTab">
                                                <li className={ this.state.isYearly ? "volTablist volTablink1 volYearlyList active" : "volTablist volTablink1 volYearlyList" } onClick={ () => { this.setState({ isYearly: true, errorMessg: "" }); } } style={ { display: this.state.sizeOfBackup >= 10 ? "block" : "none" } }>Yearly</li>
                                                <li className={ this.state.isYearly ? "volTablist volTablink1 volMonthlyList" : "volTablist volTablink1 volMonthlyList active" } onClick={ () => { this.setState({ isYearly: false, errorMessg: "" }); } }>Monthly</li>
                                            </ul>
                                            <div id="resvolYearly" className="createVol_content_wrpr createVol_content_wrap volYearly" style={ { display: this.state.isYearly ? "block" : "none" } }>
                                                <div className="offer-text-blk">
                                                    <p className="saveoffer-txt">
                                                        <span className="red-hht-txt">{ this.state.discPerce }%<sup>*</sup>
                                                        </span> OFF for the first year</p>
                                                </div>
                                                <div className="volsliderInnerWrap">
                                                    <div className="createVol_sec">
                                                        <p className="info_txt">
                                                            Volumes are billed at <span className="old-price">${ (this.state.volPrice * 12).toFixed(2) }</span>/GB/Year <b>${ ((this.state.volPrice * 12) - ((this.state.volPrice * 12) / this.state.discVal)).toFixed(2) }</b>/GB for the first year.
                                                        </p>
                                                        <p className="info_txt">The size of your volume may range from 1 GB to 1 TB (1000 GB).
                                                            For yearly volumes, the size must be greater than 10 GB and for monthly volumes it must be greater than 1 GB.</p>
                                                        <p>Volume will be created.</p>
                                                        <div className="common_txtBox_row">
                                                            <label>New volume name</label>
                                                            <input id="volName1" type="text" name="volumeName" value={ this.state.volumeName } onChange={ (e) => this.formHandler(e) } className="txt_box" placeholder="Provide a name for the volume" autoComplete="off" onKeyDown={ (e) => this.onBackupKeyDown(e, 'restoreBackup') } maxLength="20" />
                                                            <p className="comm_error_msg">{ this.state.errorMessg }</p>
                                                        </div>
                                                        <div className="cta_wrap">
                                                            <input type="button" name="" value="Restore Backup" className="common_cta_btn blue" onClick={ () => this.restoreBackup() } />
                                                            <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ () => this.volumeClose() } />
                                                        </div>
                                                        <div className="common_txtBox_row">
                                                            <b>Note:</b>
                                                            <p>- The 90% offer is applicable for the first year only. For subsequent years, normal charges are applicable.</p>
                                                            <p>- Any charges incurred for the volume will not be refunded on deleting the volume.</p>


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="resvolMonthly" className="createVol_content_wrpr createVol_content_wrap volMonthly" style={ { display: this.state.isYearly ? "none" : "block" } }>
                                                <div className="offer-text-blk">
                                                    <p className="saveoffer-txt">Pay as you use with monthly plan</p>
                                                </div>
                                                <div className="volsliderInnerWrap">
                                                    <p className="info_txt">Volumes are billed per month at <b>${ this.state.volPrice }/GB</b>.</p>
                                                    <p className="info_txt">The size of your volume may range from 1 GB to 1 TB (1000 GB).
                                                        For yearly volumes, the size must be greater than 10 GB and for monthly volumes it must be greater than 1 GB.</p>
                                                    <p>Volume will be created.</p>
                                                    <div className="common_txtBox_row">
                                                        <label>New volume name</label>
                                                        <input id="volName1" type="text" name="volumeName" value={ this.state.volumeName } onChange={ (e) => this.formHandler(e) } className="txt_box" placeholder="Provide a name for the volume" autoComplete="off" onKeyDown={ (e) => this.onBackupKeyDown(e, 'restoreBackup') } maxLength="20" />
                                                        <p className="comm_error_msg">{ this.state.errorMessg }</p>
                                                    </div>
                                                    <div className="cta_wrap">
                                                        <input type="button" name="" value="Restore Backup" className="common_cta_btn blue" onClick={ () => this.restoreBackup() } />
                                                        <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ () => this.volumeClose() } />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="existwVolRestore" style={ { display: this.state.isNewVolumeRestore ? "none" : "block" } }>
                                            <p className="info_txt" >Select a volume to restore from the list. Only volumes that are currently online and are equal or greater than in size of the backup will be available.</p>
                                            <p className="imp_warn_note" style={ { color: 'red' } }><strong>Warning:</strong> On restoring to an existing volume, all  data on the volume will be overwritten. This operation is irreversible.</p>
                                            <div className="common_txtBox_row">
                                                <div className="custom_select_box" >
                                                    <select name="selectedVolume" value={ this.state.selectedVolume } onChange={ (e) => this.formHandler(e) }>
                                                        { this.state.regionVolumeList.length === 0 ? <option value='' default>No volume available</option> : <option value='' style={ { display: "none" } } default>Select a volume to restore</option> }
                                                        { this.state.regionVolumeList.map((volume, i) =>
                                                            <option key={ i } value={ volume.id } >{ volume.name }</option>
                                                        ) }
                                                    </select>
                                                </div>

                                                <p className="comm_error_msg">{ this.state.volErrorMessg }</p>
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" value="Restore Backup" className="common_cta_btn blue" onClick={ () => this.restoreBackup() } />
                                                <input type="button" name="" value="Cancel" className="common_cta_btn transparentGrey" onClick={ () => this.volumeClose() } />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );
    }

}

function formatDate(d) {
    return d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + d.toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
    //return d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',' + d.getFullYear() + ' ' + (d.getUTCHours() < 10 ? '0' : '') + d.getUTCHours() + ':' + (d.getUTCMinutes() < 10 ? '0' : '') + d.getUTCMinutes();
}